// Platforms and carriers have their own sections, and fulfillment belongs with the carriers, so an
// app of REVER's catalog is anything with another category.
const NOT_APP_TAGS = ['platforms', 'shipping', 'fulfillment']

export const isHubApp = (tags: string[]) =>
  tags.some((tag) => !NOT_APP_TAGS.includes(tag))

// What REVER does with an app. Apps that work the same way share one, which names the app.
export type AppAbout =
  | 'gorgias'
  | 'zendesk'
  | 'holded'
  | 'ai_support'
  | 'naiz_fit'
  | 'usizy'
  | 'refund_gateway'

// Keyed by the catalog's app name, written as appKey writes it.
const APP_ABOUT: Record<string, AppAbout> = {
  gorgias: 'gorgias',
  zendesk: 'zendesk',
  holded: 'holded',
  digitalgenius: 'ai_support',
  yuma: 'ai_support',
  naizfit: 'naiz_fit',
  usizy: 'usizy',
  klarna: 'refund_gateway',
  adyen: 'refund_gateway',
  axerve: 'refund_gateway',
  paypal: 'refund_gateway',
  redsys: 'refund_gateway',
  sequra: 'refund_gateway'
}

// The catalog's names were typed by hand ("Naiz_Fit", "Digital Genius"), so only the letters and digits count.
const appKey = (name: string) => name.toLowerCase().replace(/[^a-z0-9]/g, '')

export const appAboutOf = (name: string): AppAbout | undefined =>
  APP_ABOUT[appKey(name)]
